unit Narocila;

interface

uses
  System.SysUtils, System.Classes, Vcl.Forms, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection, WEBLib.ExtCtrls, WEBLib.DB, WEBLib.DBCtrls, WEBLib.Grids, MobileForm, Vcl.Grids, DB,
  WEBLib.WebCtrls;

type
  TfrmNarocila = class(TForm) //TMobileForm
    wdsView: TXDataWebDataSet;
    dsView: TDataSource;
    wdsViewDatumDostave: TDateField;
    wdsViewLokacijaOpis: TStringField;
    wdsViewStatusOpis: TStringField;
    btnOdjava: TButton;
    btnNovo: TButton;
    lblNaslov: TLabel;
    wdsViewId: TIntegerField;
    btnGeslo: TButton;
    gridView: TDBTableControl;
    procedure FormShow(Sender: TObject);
    procedure FormCreate(Sender: TObject);
    procedure btnMoveClick(Sender: TObject);
    procedure btnSelectClick(Sender: TObject);
    procedure gridViewClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure btnGesloClick(Sender: TObject);
    procedure gridViewGetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
  protected
    procedure ApplyTheme(Dark: boolean); reintroduce;
  private
    { Private declarations }
    FConnected: boolean;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmNarocila: TfrmNarocila;

implementation

{$R *.dfm}

uses Main, Client.Core, Client.Settings, Auth.Service, Constants;

procedure TfrmNarocila.ApplyTheme(Dark: boolean);
begin
  inherited;
end;

procedure TfrmNarocila.btnGesloClick(Sender: TObject);
begin
  frmMain.ShowRegistracija(gnMenjavaGesla);
end;

procedure TfrmNarocila.btnMoveClick(Sender: TObject);
begin
  frmMain.ShowLogin;
end;

procedure TfrmNarocila.btnSelectClick(Sender: TObject);
begin
  frmMain.ShowNalog;
end;

procedure TfrmNarocila.FormCreate(Sender: TObject);
var Qry: string;
begin
  inherited;
  Qry := '$filter=stranka/id eq '+modMain.StrankaId.ToString+'&$orderby=datumdostave desc&$expand=status,stranka&$top=10';

  wdsView.QueryString := Qry;
  wdsView.Load;
end;

procedure TfrmNarocila.FormShow(Sender: TObject);
begin
  inherited;
  ApplyTheme(AppSettings.DarkMode);
end;

procedure TfrmNarocila.gridViewClickCell(Sender: TObject; ACol, ARow: Integer);
begin
  modMain.Log(gridView.Cells[0, ARow]);
  frmMain.ShowNalogInfo(StrToIntDef(gridView.Cells[0, ARow], 0));
end;

procedure TfrmNarocila.gridViewGetCellClass(Sender: TObject; ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ACol = 3 then begin
    if AValue = 'Vnešen' then begin
      AClassName := 'text-warning text-wrap';
    end;

    if AValue = 'V obdelavi' then begin
      AClassName := 'text-danger text-wrap';
    end;

    if AValue = 'Obdelan' then begin
      AClassName := 'text-success text-wrap';
    end;
  end;
end;

procedure TfrmNarocila.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblNaslov := TLabel.Create('lblNaslov');
  btnOdjava := TButton.Create('btnOdjava');
  btnNovo := TButton.Create('btnNovo');
  btnGeslo := TButton.Create('btnGeslo');
  gridView := TDBTableControl.Create('gridView');
  wdsView := TXDataWebDataSet.Create(Self);
  wdsViewDatumDostave := TDateField.Create(Self);
  wdsViewLokacijaOpis := TStringField.Create(Self);
  wdsViewStatusOpis := TStringField.Create(Self);
  wdsViewId := TIntegerField.Create(Self);
  dsView := TDataSource.Create(Self);

  lblNaslov.BeforeLoadDFMValues;
  btnOdjava.BeforeLoadDFMValues;
  btnNovo.BeforeLoadDFMValues;
  btnGeslo.BeforeLoadDFMValues;
  gridView.BeforeLoadDFMValues;
  wdsView.BeforeLoadDFMValues;
  wdsViewDatumDostave.BeforeLoadDFMValues;
  wdsViewLokacijaOpis.BeforeLoadDFMValues;
  wdsViewStatusOpis.BeforeLoadDFMValues;
  wdsViewId.BeforeLoadDFMValues;
  dsView.BeforeLoadDFMValues;
  try
    Name := 'frmNarocila';
    Width := 640;
    Height := 575;
    Align := alClient;
    Color := clBtnFace;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -27;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'FormCreate');
    SetEvent(Self, 'OnShow', 'FormShow');
    lblNaslov.SetParentComponent(Self);
    lblNaslov.Name := 'lblNaslov';
    lblNaslov.Left := 213;
    lblNaslov.Top := 8;
    lblNaslov.Width := 99;
    lblNaslov.Height := 37;
    lblNaslov.Caption := 'Naro'#269'ila';
    lblNaslov.Color := clBtnFace;
    lblNaslov.ElementFont := efCSS;
    lblNaslov.ElementPosition := epIgnore;
    lblNaslov.HeightStyle := ssAuto;
    lblNaslov.HeightPercent := 100.000000000000000000;
    lblNaslov.WidthStyle := ssAuto;
    lblNaslov.WidthPercent := 100.000000000000000000;
    btnOdjava.SetParentComponent(Self);
    btnOdjava.Name := 'btnOdjava';
    btnOdjava.Left := 240;
    btnOdjava.Top := 504;
    btnOdjava.Width := 96;
    btnOdjava.Height := 25;
    btnOdjava.ChildOrder := 2;
    btnOdjava.ElementFont := efCSS;
    btnOdjava.ElementPosition := epIgnore;
    btnOdjava.HeightStyle := ssAuto;
    btnOdjava.HeightPercent := 100.000000000000000000;
    btnOdjava.WidthStyle := ssAuto;
    btnOdjava.WidthPercent := 100.000000000000000000;
    SetEvent(btnOdjava, Self, 'OnClick', 'btnMoveClick');
    btnNovo.SetParentComponent(Self);
    btnNovo.Name := 'btnNovo';
    btnNovo.Left := 408;
    btnNovo.Top := 504;
    btnNovo.Width := 96;
    btnNovo.Height := 25;
    btnNovo.ChildOrder := 3;
    btnNovo.ElementFont := efCSS;
    btnNovo.ElementPosition := epIgnore;
    btnNovo.HeightStyle := ssAuto;
    btnNovo.HeightPercent := 100.000000000000000000;
    btnNovo.WidthStyle := ssAuto;
    btnNovo.WidthPercent := 100.000000000000000000;
    SetEvent(btnNovo, Self, 'OnClick', 'btnSelectClick');
    btnGeslo.SetParentComponent(Self);
    btnGeslo.Name := 'btnGeslo';
    btnGeslo.Left := 120;
    btnGeslo.Top := 504;
    btnGeslo.Width := 48;
    btnGeslo.Height := 25;
    btnGeslo.ChildOrder := 4;
    btnGeslo.ElementFont := efCSS;
    btnGeslo.ElementPosition := epIgnore;
    btnGeslo.HeightStyle := ssAuto;
    btnGeslo.HeightPercent := 100.000000000000000000;
    btnGeslo.WidthStyle := ssPercent;
    btnGeslo.WidthPercent := 100.000000000000000000;
    SetEvent(btnGeslo, Self, 'OnClick', 'btnGesloClick');
    gridView.SetParentComponent(Self);
    gridView.Name := 'gridView';
    gridView.Left := 136;
    gridView.Top := 120;
    gridView.Width := 329;
    gridView.Height := 257;
    gridView.ElementClassName := 'table';
    gridView.HeightStyle := ssAuto;
    gridView.WidthStyle := ssAuto;
    gridView.HeightPercent := 90.000000000000000000;
    gridView.BorderColor := clSilver;
    gridView.ChildOrder := 2;
    gridView.ElementFont := efCSS;
    gridView.ElementHeaderClassName := 'thead-dark fs-8';
    gridView.ElementPosition := epIgnore;
    gridView.ElementTableClassName := 'table table-striped table-bordered table-hover fs-8';
    SetEvent(gridView, Self, 'OnClickCell', 'gridViewClickCell');
    SetEvent(gridView, Self, 'OnGetCellClass', 'gridViewGetCellClass');
    gridView.Columns.Clear;
    with gridView.Columns.Add do
    begin
      ElementClassName := 'd-none';
      DataField := 'Id';
      Title := 'Id';
      TitleElementClassName := 'd-none';
    end;
    with gridView.Columns.Add do
    begin
      ElementClassName := 'col-3';
      DataField := 'DatumDostave';
      Title := 'Datum';
      TitleElementClassName := 'col-3';
    end;
    with gridView.Columns.Add do
    begin
      ElementClassName := 'col-6 text-wrap';
      DataField := 'LokacijaOpis';
      Title := 'Lokacija';
      TitleElementClassName := 'col-6 text-wrap';
    end;
    with gridView.Columns.Add do
    begin
      ElementClassName := 'col-3';
      DataField := 'Status.Opis';
      Title := 'Status';
      TitleElementClassName := 'col-3';
    end;
    gridView.DataSource := dsView;
    wdsView.SetParentComponent(Self);
    wdsView.Name := 'wdsView';
    wdsView.EntitySetName := 'PrevozniNalog';
    wdsView.Connection := modMain.connServer;
    wdsView.SubpropsDepth := 1;
    wdsView.Left := 96;
    wdsView.Top := 176;
    wdsViewDatumDostave.SetParentComponent(wdsView);
    wdsViewDatumDostave.Name := 'wdsViewDatumDostave';
    wdsViewDatumDostave.FieldName := 'DatumDostave';
    wdsViewDatumDostave.DisplayFormat := 'dd.mm.yyyy';
    wdsViewLokacijaOpis.SetParentComponent(wdsView);
    wdsViewLokacijaOpis.Name := 'wdsViewLokacijaOpis';
    wdsViewLokacijaOpis.FieldName := 'LokacijaOpis';
    wdsViewStatusOpis.SetParentComponent(wdsView);
    wdsViewStatusOpis.Name := 'wdsViewStatusOpis';
    wdsViewStatusOpis.FieldName := 'Status.Opis';
    wdsViewId.SetParentComponent(wdsView);
    wdsViewId.Name := 'wdsViewId';
    wdsViewId.FieldName := 'Id';
    dsView.SetParentComponent(Self);
    dsView.Name := 'dsView';
    dsView.DataSet := wdsView;
    dsView.Left := 96;
    dsView.Top := 232;
  finally
    lblNaslov.AfterLoadDFMValues;
    btnOdjava.AfterLoadDFMValues;
    btnNovo.AfterLoadDFMValues;
    btnGeslo.AfterLoadDFMValues;
    gridView.AfterLoadDFMValues;
    wdsView.AfterLoadDFMValues;
    wdsViewDatumDostave.AfterLoadDFMValues;
    wdsViewLokacijaOpis.AfterLoadDFMValues;
    wdsViewStatusOpis.AfterLoadDFMValues;
    wdsViewId.AfterLoadDFMValues;
    dsView.AfterLoadDFMValues;
  end;
end;

end.
